/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  sectionHeader: {
    marginBottom: 25,
  },
  image: {
    width: '100%',
  },
}));

const AcquisitionPage09 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.poslumaBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_5.path}`}
          alt={`${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_5.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 5:</Typography>
          <Typography variant="h3" className={classes.sectionHeader}>
            Image Reconstruction
          </Typography>
          <img
            className={classes.image}
            src={`${BASE_URL}${IMAGE_PATHS.POSLUMA_IMAGE_ACQ_CLIP.path}`}
            alt={`${IMAGE_PATHS.POSLUMA_IMAGE_ACQ_CLIP.alt}`}
          />
        </div>
      </div>
    </>
  );
};

export default AcquisitionPage09;
